import { render, staticRenderFns } from "./ArrayTextInput.vue?vue&type=template&id=6c20e4ee&"
import script from "./ArrayTextInput.vue?vue&type=script&lang=js&"
export * from "./ArrayTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports